import { jsxs as p, jsx as g } from "react/jsx-runtime";
import { c as h } from "react/compiler-runtime";
import * as C from "react";
import { useTheme as y } from "@mui/material/styles";
import { TreeItem as T } from "@mui/x-tree-view";
const x = C.forwardRef(function(e, c) {
  const t = h(18), m = y();
  let l, n, o, i;
  t[0] !== e ? ({
    icon: n,
    children: l,
    style: i,
    ...o
  } = e, t[0] = e, t[1] = l, t[2] = n, t[3] = o, t[4] = i) : (l = t[1], n = t[2], o = t[3], i = t[4]);
  let r;
  t[5] !== m ? (r = m.spacing(0.5), t[5] = m, t[6] = r) : r = t[6];
  let f;
  t[7] !== r ? (f = {
    display: "flex",
    alignItems: "center",
    gap: r
  }, t[7] = r, t[8] = f) : f = t[8];
  const d = f;
  let a;
  t[9] !== d || t[10] !== i ? (a = {
    ...d,
    ...i
  }, t[9] = d, t[10] = i, t[11] = a) : a = t[11];
  let s;
  return t[12] !== l || t[13] !== n || t[14] !== o || t[15] !== c || t[16] !== a ? (s = /* @__PURE__ */ p("div", { ref: c, ...o, style: a, children: [
    l,
    n
  ] }), t[12] = l, t[13] = n, t[14] = o, t[15] = c, t[16] = a, t[17] = s) : s = t[17], s;
}), _ = (I) => {
  const e = h(20);
  let c, t, m, l, n, o, i;
  e[0] !== I ? ({
    nodeId: o,
    itemId: l,
    icon: m,
    label: n,
    children: c,
    disabled: t,
    ...i
  } = I, e[0] = I, e[1] = c, e[2] = t, e[3] = m, e[4] = l, e[5] = n, e[6] = o, e[7] = i) : (c = e[1], t = e[2], m = e[3], l = e[4], n = e[5], o = e[6], i = e[7]);
  const r = l ?? o;
  if (!r)
    return null;
  let f;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = {
    iconContainer: x
  }, e[8] = f) : f = e[8];
  let d;
  e[9] !== m ? (d = {
    icon: m
  }, e[9] = m, e[10] = d) : d = e[10];
  const a = d;
  let s;
  e[11] !== a ? (s = {
    iconContainer: a
  }, e[11] = a, e[12] = s) : s = e[12];
  let u;
  return e[13] !== c || e[14] !== t || e[15] !== r || e[16] !== n || e[17] !== i || e[18] !== s ? (u = /* @__PURE__ */ g(T, { itemId: r, label: n, disabled: t, sx: b, slots: f, slotProps: s, ...i, children: c }), e[13] = c, e[14] = t, e[15] = r, e[16] = n, e[17] = i, e[18] = s, e[19] = u) : u = e[19], u;
};
function b(I) {
  return {
    "& .MuiTreeItem-content": {
      minHeight: 28,
      paddingLeft: `calc(${I.spacing(0.5)} + var(--TreeView-itemDepth) * var(--TreeView-itemChildrenIndentation))`,
      alignItems: "center",
      py: 1
    },
    "& .MuiTreeItem-iconContainer": {
      width: "auto",
      minWidth: 18,
      alignItems: "center",
      display: "flex"
    },
    "& .MuiTreeItem-iconContainer .MuiSvgIcon-root": {
      display: "block",
      fontSize: "1.1rem"
    }
  };
}
export {
  _ as default
};
